var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meta-referrals" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "referrals" }, [
        _vm.contact.metaReferrals.length === 0
          ? _c("div", { staticClass: "no-referrals" }, [
              _c("i", { staticClass: "fas fa-info-circle" }),
              _vm._v(" "),
              _c("p", [_vm._v("Meta reklam etkileşimi bulunmamaktadır.")]),
            ])
          : _c(
              "div",
              _vm._l(_vm.contact.metaReferrals, function (ad) {
                return _c(
                  "div",
                  { key: ad.id, staticClass: "referrals-item" },
                  [
                    _c("div", { staticClass: "headline" }, [
                      _c("a", { attrs: { href: ad.sourceLink } }, [
                        _vm._v(_vm._s(ad.headline)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.$moment(ad.createdAt).fromNow())),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _vm._v(_vm._s(ad.body)),
                    ]),
                  ]
                )
              }),
              0
            ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("h5", [_vm._v("Meta Referrals")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }